import { UserType } from '@/types/UserType'
import { logout } from '@/utils/Functions'
import { Building2Icon, CalendarCheck, HomeIcon, LogOutIcon, MenuIcon, TruckIcon, UsersIcon } from 'lucide-react'
import React from 'react'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import { Col, Image, Offcanvas, Row } from 'react-bootstrap'
import { Title } from './lib/Title'
import useMediaQuery from '@/hooks/use-media-query'

const MD_BREAKPOINT = '(min-width: 769px)'

function TopBarApp({title}: {title: string}) {
  const isDesktop = useMediaQuery(MD_BREAKPOINT)
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/connexion')
  }

  // État pour stocker les données de l'utilisateur
  const [userData, setUserData] = React.useState<UserType>()

  const [show, setShow] = React.useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  React.useEffect(() => {
    const storedUserData = localStorage.getItem(import.meta.env.VITE_APP_SESSION_USER)
    if (storedUserData) {
      const parsedUserData = JSON.parse(storedUserData)
      setUserData(parsedUserData)
    }
  }, [])

  return (
    <nav className='navbar navbar-expand navbar-light shadow bg-white topbar mb-4 h-10 sticky-top'>
      <Row className='d-flex justify-content-center align-items-center w-100'>
        <Col xs={2}>
        {!isDesktop && (
          <MenuIcon size={25} className='d-lg-none mx-3' onClick={handleShow} />
        )}
          <Offcanvas show={show} onHide={handleClose} className='w-75 bg-dark-easy text-white'>
            <Offcanvas.Header>
              <Offcanvas.Title className='d-flex align-items-center gap-2'>
                <Image src={'/img/easyLogo.ico'} alt='logo' width={40} />
                <span>Easy Box</span>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body
              className='d-flex flex-column justify-content-between'
              onClick={handleClose}
            >
              <div className='py-4'>
                <Link className='nav-link' to='/societes'>
                  <div className='d-flex align-items-center gap-2 '>
                    <span>
                      <Building2Icon size={30} />
                    </span>
                    <span>Sociétés</span>
                  </div>
                </Link>
              </div>
              <div className='py-4'>
                <NavLink className='d-flex align-items-center gap-2' to='/lockers'>
                  <HomeIcon size={30} />
                  <span>Machines</span>
                </NavLink>
              </div>
              <div className='py-4'>
                <NavLink className='d-flex align-items-center gap-2' to='/bookings'>
                  <CalendarCheck size={30} />
                  <span>Bookings</span>
                </NavLink>
              </div>
              <div className='py-4'>
                <NavLink className='d-flex align-items-center gap-2' to='/livraisons'>
                  <TruckIcon size={30} />
                  <span>Livraisons</span>
                </NavLink>
              </div>
              <div className='py-4'>
                <NavLink className='d-flex align-items-center gap-2' to='/utilisateurs'>
                  <UsersIcon size={30} />
                  <span>Utilisateurs</span>
                </NavLink>
              </div>
              <hr className='sidebar-divider border-white' />
              <div className='d-flex flex-column' >
                <div className='d-flex align-items-center gap-2'>
                  <Image
                    src={'/img/avatar-default.png'}
                    alt='Image'
                    className='img-fluid my-3'
                    width={30}
                  />
                  <div>{userData?.firstName}</div>
                </div>
                <div className='d-flex align-items-center gap-2 mt-2' onClick={handleLogout}>
                  <LogOutIcon size={25} />
                  Déconnectez vous
                </div>
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        </Col>
        <Col xs={8} className='d-flex justify-content-center align-items-center'>
          <div className='d-flex justify-content-center align-items-center w-100'>
            <Title name={title} />
          </div>
        </Col>
        <Col xs={2}></Col>
      </Row>
    </nav>
  )
}

export default TopBarApp
